import { api } from './client';

export interface ErrorLogEntry {
  source: 'backend' | 'frontend';
  error_code: string;
  http_status: number | null;
  method: string | null;
  path: string;
  message: string | null;
  occurrences: number;
  first_seen: string;
  last_seen: string;
}

export const fetchErrorLog = (): Promise<{ errors: ErrorLogEntry[] }> =>
  api.get<{ errors: ErrorLogEntry[] }>('/errors').then((r) => r.data);

export const clearErrorLog = (status?: number): Promise<{ ok: boolean; deleted: number }> =>
  api.delete<{ ok: boolean; deleted: number }>('/errors', { params: status ? { status } : undefined })
    .then((r) => r.data);
